import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './Main/i18n';
import App from './Main/App';
import * as serviceWorker from './serviceWorker';
import {get} from './Lib/auth/Api/session';
import SessionData from "./Lib/auth/Records/SessionData";
import Immutable from "immutable";
import {build} from "./Lib/routing";
import {config} from "./Main/routes";


function render(sessionData) {

    const {navTree, routingMap} = build(config, sessionData.get('roles'));

    const authStoreInit = Immutable.Map({
        session: sessionData
    });

    const appStoreInit = Immutable.Map({
        routingMap: routingMap,
        navTree: navTree
    });

    ReactDOM.render(
        <App authStoreInit={authStoreInit} appStoreInit={appStoreInit}/>,
        document.getElementById('root')
    );
}

// Get the session from the server if there is one. Will create anonymous
// session data in case there is an expired server session.

get(
    sessionData => render(sessionData),
    () => render(new SessionData())
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
